import { environment } from '../../../../../../environments/environment';
import { Quotation } from '../../../../../sale/model';
const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
const currencyCode = user ? user.user.currencyCode : '';

  export const cancellationMultiple = {
    show: 'Seleccione solo las cotizaciones pendientes a aprobar',
    columns: [
      {
        title: 'N° Cotización',
        name: 'quotationNumber',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.quotationNumber
      },
      {
        title: 'Estado',
        name: 'origin',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.state.capitalize()
      },
      {
        title: 'Monto',
        name: 'price',
        type: 'string',
        class: 'right',
        value: (element: Quotation) => `${currencyCode}/${element.quotationInfo.totalAmount}`
      }
    ]
  };